/* eslint-disable ember/no-classic-components, ember/require-tagless-components */
import { classNames } from '@ember-decorators/component';
import Component from '@ember/component';

@classNames('layout-row', 'layout-align-start-center')
export default class NzMoePrivacyFlag extends Component {}
